// extracted by mini-css-extract-plugin
module.exports = {"container":"DrawerContentUnAuthorizedError-container","text":"DrawerContentUnAuthorizedError-text","image":"DrawerContentUnAuthorizedError-image"};